import {UserContextDetails} from "@bounce/shared/consumer/declarations";
import {useEffect} from "react";
import {HAPPY_MONEY_PORTAL_URL} from "@bounce/shared/constants";

export const useRedirectNoActivePlan = (shouldRedirect: boolean, userContext?: UserContextDetails): boolean => {
  const isRedirecting = shouldRedirect && !!userContext && !userContext.is_eligible_global_login;

  useEffect(() => {
    if (isRedirecting) {
      window.location.href = HAPPY_MONEY_PORTAL_URL;
    }
  }, [isRedirecting]);

  return isRedirecting;
};
